import Immutable from 'immutable'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { orderModel } from '@features/my-gousto-page/src/models/orderModel'

import userActions, { userFetchReferralOffer } from 'actions/user'
import { getBasketOrderDetails } from 'selectors/basket'
import { isOrderConfirmationPageLoading } from 'selectors/orderConfirmation'
import { locationQuery } from 'selectors/routing'
import { getAgeVerified } from 'selectors/user'

import { OrderConfirmation } from './OrderConfirmation'
import { getHeaderDetails, isFiveForFour } from './helper'

const mapStateToProps = (state) => {
  const locationQueryParam = locationQuery(state)
  const order = getBasketOrderDetails(state)
  const headerDetails = !!order && getHeaderDetails(order)
  const showHeader = !!(locationQueryParam && locationQueryParam.order_action) && !!headerDetails
  const showMultipleBoxesDeliveryMessage = !!order && isFiveForFour(order)
  const isLoading = !order || isOrderConfirmationPageLoading(state)
  const showDuplicateOrdersModal = state.temp.get('closeOrderIds', Immutable.Map([])).size > 1
  const model = orderModel()
  const canEditOrder = !!order && model.isOrderEditable(order.toJS())
  const orderId = !!order && order.get('id')

  return {
    ageVerified: getAgeVerified(state),
    headerDetails,
    isLoading,
    showDuplicateOrdersModal,
    showHeader,
    showMultipleBoxesDeliveryMessage,
    canEditOrder,
    orderId,
  }
}

const mapDispatchToProps = {
  userFetchReferralOffer,
  userVerifyAge: userActions.userVerifyAge,
  userLoadData: userActions.userLoadData,
}

const OrderConfirmationContainer = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OrderConfirmation),
)

export { OrderConfirmationContainer }
